<template>
  <div v-if="isReady"
    class="container mx-auto"
    id="Outline">
    <header class="header">
      <img class="img-resp"
        src="@/assets/images/views/outline/logobar.jpg"
        alt="">
    </header>
    <main class="main">
      <header class="main__head text-align-center mb-md">
        <h1 class="header__title text-primary ">
          {{ reportData.stockName }}
        </h1>
        <h2 class="header__subTitle
                   text-light
                   fw-md">{{ reportData.stockSID }}&nbsp;{{ reportData.subIndustryName }}</h2>
      </header>
      <article class="main__body">
        <section class="card mb-md">
          <ul class="card__list ">
            <li class="card__item ">
              <div class="dialog">
                <p class="dialog__title">報告日期</p>
                <p class="dialog__desc text-sm text-demiLight fw-md">{{
                  formatDate(reportData.reportTime) }}</p>
              </div>
              <div class="dialog">
                <p class="dialog__title">當日收盤價</p>
                <p class="dialog__desc
                          dialog__desc--price
                          dialog__desc--closePrice
                          text-demiLight
                          fw-md">{{ reportData.closePrice }}</p>
              </div>
            </li>
            <li class="card__item">
              <div class="dialog">
                <p class="dialog__title">目標價</p>
                <p class="dialog__desc
                          dialog__desc--price
                          dialog__desc--targetPrice
                          text-demiLight
                          fw-md">{{ reportData.targetPrice }}</p>
              </div>
              <div class="dialog">
                <p class="dialog__title">隱含漲跌幅</p>
                <p v-if="reportData.closePrice && reportData.targetPrice"
                  :class="getChange > 0 ? 'dialog__desc--up text-alert' : 'dialog__desc--down text-success'"
                  class="dialog__desc dialog__desc--change fw-md">{{
                    Math.abs(getChange) }}%</p>
              </div>
            </li>
            <li class="card__item">
              <div class="rating dialog dialog-full text-align-center">
                <p class="dialog__title">投資評等</p>
                <p :class="ratingClass"
                  class="
                dialog__desc dialog__desc--rating fw-bold">{{ reportData.ratingName }}</p>
              </div>
            </li>
          </ul>
        </section>
        <section class="sect">
          <div class="dotted-line flex flex-center mb-md">
            <img class="icon icon-book"
              src="@/assets/images/views/outline/book.png">
            <h5 class="text text-primary text-sm fw-md">元大觀點</h5>
          </div>
          <div class="flex summary mb-md">
            <img class="icon icon-arrow"
              src="@/assets/images/views/outline/arrow.png">
            <h4 class="summary__text text-demiLight fw-bold">{{ reportData.heading }}</h4>
          </div>
          <ul v-for="(item, id) in reportData.opinions"
            :key="`opinion__${id}`"
            class="note__list">
            <li class="note__item mb-sm">
              <p class="note__num text-sm text-secondary fw-bold">{{ formatOrder(id) }}</p>
              <p class="note__desc text-demiLight fw-md">{{ item }}</p>
            </li>
          </ul>
        </section>
      </article>
    </main>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'OutlineView',
  data() {
    return {
      reportData: {
        stockName: '台積電',
        stockSID: 2330,
        subIndustryName: '半導體產業',
        reportTime: '2023-03-20T00:00:00',
        closePrice: 300,
        targetPrice: 600,
        rating: 'Neutral_beyond_peers',
        ratingName: '持有-超越同業',
        heading: '多元布局悄然成形，地緣政治風險逐步降低',
        opinions: [
          '下修台積電2023年EPS 5%，主要針對1H23 5/7nm稼動率假設進行下修，以反映更為疲弱之消費性需求。',
          '因日本具備完整設備、材料、供應鏈，在考量地緣政治風險以及成本效益下，預估日本有望成為下一個先進製程擴張據點。',
          '重申買進評等，晶圓代工龍頭地位確立，將使得其中長線動能無慮，目標價600元係根據16倍2023年預估EPS推得。',
        ],
      },
      isReady: false,
    };
  },
  computed: {
    getChange() {
      const { closePrice, targetPrice } = this.reportData;
      const change = (targetPrice - closePrice) / closePrice;
      return (change * 100).toFixed(1);
    },
    ratingClass() {
      switch (this.reportData.rating) {
        case 'buy':
          return 'text-buy text-lg';
        case 'Neutral_behind_peers':
          return 'text-secondary';
        case 'Neutral_beyond_peers':
          return 'text-secondary';
        case 'NR':
          return 'text-secondary';
        case 'sell':
          return 'text-gray text-lg';
        default:
          return '';
      }
    },
  },
  methods: {
    async getReportByApi() {
      const { publicApi } = this.$api;
      const res = await publicApi.getReportOutline(this.$route.query.sid);
      if (res.errorStatus) {
        // eslint-disable-next-line no-alert
        alert(res.message);
        throw res.message;
      }

      this.isReady = true;
      this.reportData = res.data;
    },
    formatDate(date) {
      return dayjs(date).format('YYYY.MM.DD');
    },
    formatOrder(num) {
      return `0${num + 1}`;
    },
  },
  mounted() {
    this.getReportByApi();
  },
};
</script>

<style scoped>
#Outline {
  font-family: 'Noto Sans TC', sans-serif;
}

.mb-sm {
  margin-bottom: 0.75rem;
}

.mb-md {
  margin-bottom: 1.25rem;
}

.mb-lg {
  margin-bottom: 1.5rem;
}

.fw-md {
  font-weight: 500;
}

.fw-bold {
  font-weight: 700;
}

.container {
  background-color: #fff;
  min-height: 100vh;
  max-width: 480px;
  width: 100%;
}

.text-primary {
  color: rgb(49, 96, 152);
}

.text-secondary {
  color: #2F80ED;
}

.text-light {
  color: rgb(130, 130, 130);
}

.text-demiLight {
  color: #323232;
}

.text-alert {
  color: #F53F3F;
}

.text-success {
  color: #13887B;
}

.text-gray {
  color: #44546A;
}

.text-buy {
  color: #DD2D2D;
}

.text-sm {
  font-size: 1rem;
}

.text-md {
  font-size: 1.25rem;
}

.text-lg {
  font-size: 1.6rem;
}

.text-align-center {
  text-align: center;
}

.header__title {
  font-size: 1.875rem;
  line-height: 1.2;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.header__subTitle {
  font-size: 1.125rem;
}

.main {
  padding: 0.75rem 1rem;
}

.card__list {
  display: flex;
  gap: 0.8125rem;
  width: 100%;
}

.card__item {
  width: 33.33333%;
  min-height: 140px;
  padding: 0.65rem;
  border: 2px solid rgba(49, 96, 152, 0.75);
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 3px 5px;
}

.dialog {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.dialog-full {
  height: 100%;
}

.dialog+.dialog {
  border-top: 1px dashed rgba(49, 96, 152, 0.75);
  padding-top: 0.5rem;
  margin-top: 0.5rem;
}

.dialog__desc--change {
  font-size: 0.875rem;
}

.dialog__desc--change::before {
  content: '';
  display: inline-block;
  border: 3px solid transparent;
  margin-right: 0.25rem;
  vertical-align: middle;
}

.dialog__desc--up::before {
  border-bottom: 5px solid #F53F3F;
  margin-top: -3px;
}

.dialog__desc--down::before {
  border-top: 5px solid #13887B;
  margin-top: 3px;
}

.dialog__desc--price::after {
  content: 'NT$';
  font-size: 0.75rem;
  margin-left: 0.25rem;
  font-weight: 400;
  color: #323232;
}

.dialog__desc--closePrice {
  font-size: 0.875rem;
}

.dialog__desc--targetPrice {
  font-size: 1.5rem;
  line-height: 1.1;
}

.rating.dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.rating .dialog__desc {
  font-size: 1.25rem;
}

.rating .dialog__desc.text-lg {
  font-size: 1.25rem;
}

.dialog__title {
  line-height: 1.4;
  margin-bottom: 5px;
  font-size: 1rem;
  color: #323232;
  font-weight: 350;
}

.dotted-line {
  position: relative;
}

.dotted-line::before {
  position: absolute;
  top: 12px;
  left: 0;
  content: "";
  width: 36%;
  border-top: 1px dashed rgba(49, 96, 152, 0.75);
}

.dotted-line::after {
  position: absolute;
  top: 12px;
  right: 0;
  content: "";
  width: 36%;
  border-top: 1px dashed rgba(49, 96, 152, 0.75);
}

.dotted-line .text {
  color: #316098;
}

.dotted-line .icon {
  width: 20px;
}

.summary .icon {
  max-width: 26px;
  max-height: 30px;
  margin-right: 1rem;
}

.summary__text {
  padding-left: 0.75rem;
  border-left: 3px solid #000;
  font-size: 1.125rem;
  text-align: justify;
}

.note__item {
  display: flex;
  gap: 0.75rem;
}

.note__desc {
  font-size: 1.0625rem;
}

.note__list {
  text-align: justify;
}

.sect {
  margin-bottom: 30px;
}
</style>
